import { IMAGES } from "../lib/images";
import { Reveal } from "./Reveal";

const milestones = [
  { year: "1985", text: "Nasce Cobi Meccanica, officina di lavorazione meccanica a Modena." },
  { year: "1995", text: "Trasferimento in un nuovo insediamento nella Zona Industriale Torrazzi." },
  { year: "1999", text: "Certificazione UNI EN ISO 9001 rilasciata dall'ente TÜV Italia." },
  { year: "2015", text: "Primo importante allargamento del parco macchine." },
  { year: "2021", text: "Già protagonista della storia aziendale, la famiglia Della Rocca acquisisce il 100% della società, segnando l'inizio di una nuova fase di crescita, investimenti e sviluppo." },
  { year: "2023", text: "Espansione con un nuovo capannone e ulteriore ampliamento del parco macchine." },
  { year: "Oggi", text: "Tre sedi produttive, nuovo reparto rettifica, acquisto di 2 nuovi centri di lavoro a 5 assi, impianto fotovoltaico e climatizzazione integrale." },
];

export const Timeline = () => (
  <section id="storia" data-testid="timeline" className="border-t border-white/10">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-24 md:py-32 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
      <div className="lg:col-span-5">
        <Reveal>
          <div className="flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-red-600" />
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-red-600">Le nostre radici</span>
          </div>
          <h2 className="font-display font-black uppercase text-5xl md:text-7xl tracking-tighter leading-none mb-8">
            Attivi<br />dal <span className="text-red-600">1985</span>
          </h2>
          <p className="text-zinc-400 leading-relaxed max-w-md mb-10">
            Operiamo nella metalmeccanica dal 1985, facendo crescere il nome Cobi Meccanica sul territorio
            e collaborando con le più grandi aziende del distretto.
          </p>
          <div className="relative border border-white/10 overflow-hidden aspect-[16/9]">
            <img src={IMAGES.cobiGears} alt="Precisione Cobi Meccanica — archivio storico" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            <span className="absolute bottom-4 left-4 font-mono text-[11px] uppercase tracking-widest text-zinc-200">Archivio Cobi Meccanica</span>
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-7">
        <div className="border-t border-white/10">
          {milestones.map((m, i) => (
            <Reveal key={m.year} delay={i * 0.05}>
              <div data-testid={`milestone-${i}`} className="group grid grid-cols-12 gap-4 py-7 border-b border-white/10 hover:bg-white/[0.02] transition-colors">
                <div className="col-span-3 md:col-span-2">
                  <span className="font-display font-black text-2xl md:text-3xl tracking-tight text-white group-hover:text-red-600 transition-colors">{m.year}</span>
                </div>
                <div className="col-span-9 md:col-span-10 flex items-start gap-4">
                  <span className="w-1.5 h-1.5 bg-red-600 rotate-45 mt-2.5 shrink-0" />
                  <p className="text-zinc-300 leading-relaxed text-lg">{m.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
